import { useState } from "react";

// global vcontext to use global variables and methods
import { useGlobalContext } from "../../../context";

//Tooltips
import Tooltip from "../../widgets/Tooltip";

// react icons
import {
  AddAsset,
  AddAssetHover,
  Card,
  RemoveButton,
  RemoveButtonHover,
  ModalButtons,
} from "./AssetElements";
import { useTranslation } from "react-i18next";
import TranslatableText from "../../Multilanguage/TranslatableText";

export const Asset = ({ asset, setCiToRemove, setModalRemoveCI }) => {
  const [hoverButton, setHoverButton] = useState(false);
  const [hover, setHover] = useState(false);
  const { t } = useTranslation();

  const { secundaryColor } = useGlobalContext();

  return (
    <Card
      bg={secundaryColor}
      className={`w-full p-6 border border-gris rounded-lg bg-white`}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <div className="flex justify-between">
        <h1 className="font-title text-lg sm:text-xl">{asset.CIName}</h1>
        <button
          onClick={(e) => {
            setCiToRemove(asset.CIID);
            setModalRemoveCI(true);
          }}
          className={`${hover ? "visible" : "invisible"} `}
          onMouseEnter={() => setHoverButton(true)}
          onMouseLeave={() => setHoverButton(false)}
        >
          {hoverButton ? <RemoveButtonHover /> : <RemoveButton />}
        </button>
      </div>

      <p className="font-title">
        {t("requestDetail.tabAssets.id")}{" "}
        <span className="font-body">{asset.CIID}</span>
      </p>
      <p className="font-title">
        {t("requestDetail.tabAssets.dpto")}{" "}
        <span className="font-body">
          <TranslatableText text={asset.Department} />
        </span>
      </p>
      <p className="font-title">
        {t("requestDetail.tabAssets.impact")}{" "}
        <span className="font-body">
          <TranslatableText text={asset.Impact} />
        </span>
      </p>
      <p className="font-title">
        {t("requestDetail.tabAssets.location")}{" "}
        <span className="font-body">
          <TranslatableText text={asset.Location} />
        </span>
      </p>
    </Card>
  );
};

// export const Asociar = ({ handleAssociateCI }) => {
//   const [hover, setHover] = useState(false);
//   return (
//     <Tooltip title="Añadir activo">
//       <button
//         onClick={(e) => {
//           handleAssociateCI();
//         }}
//         onMouseEnter={() => setHover(true)}
//         onMouseLeave={() => setHover(false)}
//       >
//         {hover ? <AddAssetHover /> : <AddAsset />}
//       </button>
//     </Tooltip>
//   );
// };

export const Asociar = (props) => {
  const { setModalActive } = props;
  const [hover, setHover] = useState(false);
  const { t } = useTranslation();

  return (
    <Tooltip title={t("requestDetail.tabAssets.addActive")}>
      <button
        className="focus:outline-none"
        onClick={() => setModalActive(true)}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        {hover ? <AddAssetHover /> : <AddAsset />}
      </button>
    </Tooltip>
  );
};

export const Confirm = (props) => {
  const { options, setModalActive, crear } = props;

  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-16 mt-5">
      <div className="p-3 break-words ">
        {options.value !== "" ? (
          <p>{`${t("requestDetail.tabAssets.createActivo")} ${
           options.label
          }?`}</p>
        ) : (
          <p>{t("requestDetail.tabAssets.emptyActive")}</p>
        )}
      </div>
      <div className="flex justify-center items-center gap-8 mx-5">
        <ModalButtons
          onClick={() => {
            setModalActive(false);
          }}
        >
          {t("requestDetail.cancel")}
        </ModalButtons>
        {options.value === "" ? (
          <ModalButtons
            bg="#00B446"
            onClick={() => {
              setModalActive(false);
            }}
          >
            {t("requestDetail.accept")}
          </ModalButtons>
        ) : (
          <ModalButtons
            bg="#00B446"
            onClick={() => {
              crear();
              setModalActive(false);
            }}
          >
            {t("requestDetail.create")}
          </ModalButtons>
        )}
      </div>
    </div>
  );
};

export const ConfirmRemoveCi = (props) => {
  const { setModalActive, handleRemoveCI, ciToRemove } = props;

  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-8">
      <div className="p-3 break-words text-center">
        {t("requestDetail.wish")} {ciToRemove}
      </div>
      <div className="flex justify-center items-center gap-8 mx-5">
        <ModalButtons
          onClick={() => {
            setModalActive(false);
          }}
        >
          {t("requestDetail.cancel")}
        </ModalButtons>

        <ModalButtons
          bg="#FABE32"
          onClick={() => {
            handleRemoveCI(ciToRemove);
            setModalActive(false);
          }}
        >
          {t("requestDetail.accept")}
        </ModalButtons>
      </div>
    </div>
  );
};
